export default function AIBadge({ className }) {
    return <img alt="ai badge" className={className} src={`${process.env.PUBLIC_URL}/assets/images/icon-ai.png`}/>
}